<template>
  <div>
    <v-container>
      <v-row class="py-3">
        <v-col cols="12" sm="12" mb="8" lg="8">
          <v-card flat>
            <v-card-text>
              <v-row
                style="min-height: 70vh"
                v-if="!this.$store.state.loggedIntoFacebook"
              >
                <v-col cols="12" class="text-center">
                  <h2 class="compeatfont">Welcome to Compeat</h2>
                  <p v-if="!cancelledLogin">Please sign in to Facebook</p>
                  <v-btn
                    small
                    rounded
                    @click="loginWithFacebook()"
                    class="primary mb-5"
                    :loading="facebookLoginLoading"
                  >
                    <v-icon>mdi-facebook</v-icon> Login To Facebook
                  </v-btn>
                  <p v-if="cancelledLogin" class="mt-3">
                    Signing In Session Cancelled. Please try again.
                  </p>
                  <v-img
                    src="../assets/packagelogin.png"
                    class="mx-auto"
                    style="position: absolute; bottom: 0px"
                  />
                </v-col>
              </v-row>
              <v-row
                class="mx-4"
                v-if="
                  subscriptionPersonalInfo &&
                  this.$store.state.loggedIntoFacebook
                "
              >
                <v-col cols="12" class="text-center">
                  <h1 class="steptext">Personal Info</h1>
                  <!-- <v-btn @click="deleteSubscriptions()">hello</v-btn> -->
                </v-col>
                <v-col cols="12">
                  <v-form ref="packageOneForm" v-model="packageOnevalid">
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-text-field
                          v-model="firstName"
                          label="First Name"
                          :rules="textRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-text-field
                          v-model="lastName"
                          label="Last Name"
                          :rules="textRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <vue-tel-input-vuetify
                          id="mobile"
                          v-model="mobile"
                          data-ref="mobile"
                          defaultCountry="za"
                          @input="onInput"
                          clearable
                          label=""
                        ></vue-tel-input-vuetify>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-text-field
                          v-model="email"
                          :rules="emailRules"
                          label="Email Address"
                          @input="convertToLowercase"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="text-center" v-if="demoPackage">
                        <h2 class="mb-0 compeatfont">Select Package</h2>
                        <v-select
                          v-model="selectReportType"
                          :items="packages"
                          label="Select Report Type"
                          item-text="name"
                          item-value="value"
                          @change="handleSelect"
                          class="selectpackage"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <!-- package 1 and 3-->
                    <v-row
                      v-if="
                        (packageTitle == 'Package 1' &&
                          competitiveReportData &&
                          this.$store.state.loggedIntoFacebook) ||
                        (packageTitle == 'Package 3' &&
                          competitiveReportData &&
                          this.$store.state.loggedIntoFacebook)
                      "
                    >
                      <v-col
                        cols="12"
                        v-if="
                          packageTitle == 'Package 1' ||
                          packageTitle == 'Package 3'
                        "
                        class="text-center py-0"
                      >
                        <h2
                          v-if="packageTitle == 'Package 1'"
                          class="mb-1 compeatfont"
                        >
                          Package 1
                        </h2>
                        <h2
                          v-if="packageTitle == 'Package 3'"
                          class="mb-1 compeatfont"
                        >
                          Package 3
                        </h2>
                        <v-divider v-if="packageTitle == 'Package 3'">
                        </v-divider>
                      </v-col>
                      <!-- Display when list is under 5 -->
                      <v-col
                        cols="12"
                        v-if="packagePages.length < 5 && !demoPackage"
                        class="text-center"
                      >
                        <h3>
                          You can add
                          {{ pagesToAdd - packagePages.length }} more
                          competitor(s)...
                        </h3>
                      </v-col>
                      <!-- Display when list is over 5 -->
                      <v-col
                        cols="12"
                        v-if="packagePages.length >= 5 && !demoPackage && packagePages.length < 50"
                        class="text-center"
                      >
                        <h3>
                          You can add more competitors at a cost of $10 per
                          additional competitor. Limit is 50 pages
                        </h3>
                      </v-col>
                      <!-- Facebook search field -->
                      <v-col class="col-12 pt-1" v-if="packagePages.length < 50">
                        <p class="text-center" v-if="packageTitle == 'Package 3'">*Please note in order to generate these reports accurately, access to the selected primary Facebook page is required.</p>
                        <v-menu offset-y open-on-click>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              type="text"
                              class="facebookHandleInput"
                              v-model="search"
                              :placeholder="dynamicLabel"
                              @keyup="searchForCompany()"
                              v-on="on"
                              v-bind="attrs"
                              :loading="loadingSearch"
                              append-icon="mdi-magnify"
                            />
                          </template>

                          <v-list class="listofpages" v-if="!loadingSearch">
                            <v-list-item
                              v-if="this.search == '' && !loadingSearch"
                            >
                              <v-list-item-title
                                >Type clients facebook page name or paste
                                clients facebook url
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-for="searchResult in searchResults"
                              :key="searchResult.id"
                              @click="selectCompany(searchResult)"
                            >
                              <v-avatar size="40" class="mr-2">
                                <v-img :src="searchResult.icon" />
                              </v-avatar>
                              <v-list-item-title>
                                {{ searchResult.name }}</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                          <v-list v-if="this.searchPageError">
                            <v-list-item>
                              <v-list-item-title
                                >{{ searchErrorMessage }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                          <v-list v-if="loadingSearch">
                            <v-list-item>
                              <v-list-item-title
                                >Please Wait, pages are logging
                                <v-progress-circular
                                  indeterminate
                                  color="primary"
                                >
                                </v-progress-circular
                              ></v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <!-- List of pages -->
                      <v-col v-if="packagePages != ''" cols="12">
                        <v-list>
                          <v-list-item
                            v-for="(packagePages, index) in packagePages"
                            :key="packagePages.id"
                            class="py-2"
                          >
                            <v-avatar size="40" class="mr-2">
                              <v-img :src="packagePages.icon" />
                            </v-avatar>
                            <v-list-item-content class="text-left">
                              <v-list-item-title>
                                {{ packagePages.name }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-content v-if="index == 0">
                              <v-list-item-title>
                                - Primary page
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-btn @click="deletePage(index)" icon>
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                    <!-- package 2 and 3-->
                    <v-row
                      v-if="
                        (packageTitle == 'Package 2' &&
                          insightsReportData &&
                          this.$store.state.loggedIntoFacebook) ||
                        (packageTitle == 'Package 3' &&
                          !competitiveReportData &&
                          insightsReportData &&
                          this.$store.state.loggedIntoFacebook)
                      "
                    >
                      <!-- Display if package 2 title -->
                      <v-col cols="12" class="py-0 text-center">
                        <h2 class="mb-1 compeatfont">{{ packageTitle }}</h2>
                        <v-divider>

                        </v-divider>
                      </v-col>
                      <!-- Display search for package 2 page -->
                      <v-col cols="12" v-if="packagePages.length < 1" class="pt-1">
                        <!-- <h3 class="steptext text-center mb-0">Select Page</h3> -->
                        <p class="text-center">*Please note in order to generate these reports accurately, access to the selected primary Facebook page is required.</p>
                        <v-menu offset-y open-on-click>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              type="text"
                              class="facebookHandleInput"
                              v-model="search"
                              :placeholder="dynamicLabel"
                              @keyup="searchForCompany()"
                              v-on="on"
                              v-bind="attrs"
                              :loading="loadingSearch"
                              append-icon="mdi-magnify"
                            />
                          </template>

                          <v-list class="listofpages" v-if="!loadingSearch">
                            <v-list-item
                              v-if="this.search == '' && !loadingSearch"
                            >
                              <v-list-item-title
                                >Type clients facebook page name or paste
                                clients facebook url
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-for="searchResult in searchResults"
                              :key="searchResult.id"
                              @click="selectInsightsCompany(searchResult)"
                            >
                              <v-avatar size="40" class="mr-2">
                                <v-img :src="searchResult.icon" />
                              </v-avatar>
                              <v-list-item-title>
                                {{ searchResult.name }}</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                          <v-list v-if="this.searchPageError">
                            <v-list-item>
                              <v-list-item-title
                                >{{ searchErrorMessage }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                          <v-list v-if="loadingSearch">
                            <v-list-item v-if="loadingSearch == true">
                              <v-list-item-title
                                >Please Wait, pages loading...
                                <v-progress-circular
                                  indeterminate
                                  color="frontendblue"
                                >
                                </v-progress-circular
                              ></v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <!-- Display the selected page page -->
                      <v-col v-if="packagePages != ''" cols="12">
                        <h3 class="steptext text-center mb-0">Selected Page</h3>
                        <v-list
                          v-for="(packagePages, index) in packagePages"
                          :key="packagePages.id"
                          class="py-2"
                        >
                          <v-list-item v-if="index === 0" class="py-2">
                            <v-avatar size="40" class="mr-2">
                              <v-img :src="packagePages.icon" />
                            </v-avatar>
                            <v-list-item-content class="text-left">
                              <v-list-item-title>
                                {{ packagePages.name }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-content>
                              <v-list-item-title>
                                - Primary page
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-btn
                              v-if="packageTitle == 'Package 2'"
                              @click="deletePage(index)"
                              icon
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-list-item>
                        </v-list>
                      </v-col>
                      <!-- Display checking for access loader -->
                      <v-col
                        v-if="checkingForAccess"
                        cols="12"
                        class="text-center"
                      >
                        <v-progress-circular indeterminate size="100">
                          <p class="mb-0 overlaytext">
                            Checking <br />
                            Access
                          </p>
                        </v-progress-circular>
                      </v-col>
                      <!-- Display if user has access-->
                      <v-col v-if="hasAccess" cols="12">
                        <h3 class="steptext text-center mb-0">
                          Please Select Ad Account for page.
                        </h3>
                        <p class="mb-0">
                          If you dont have ads or campaigns you can select the
                          option No Ad Account For Page.
                        </p>
                      </v-col>
                      <!-- Display if user has access-->
                      <v-col v-if="hasAccess" cols="12">
                        <v-select
                          label="Select Your AdAccount"
                          v-model="adAccountId"
                          :items="adsAccountsForPage"
                          item-text="name"
                          item-value="id"
                          :rules="textRules"
                          @change="handleSelectedAdAccount"
                        >
                        </v-select>
                      </v-col>
                      <!-- Display if user has access-->
                      <v-col v-if="hasAccess && adAccountId != 0" cols="12">
                        <v-radio-group
                          v-model="singlePage"
                          :rules="[singlePageValidation]"
                          mandatory
                        >
                          <v-radio
                            label="Stand alone Account"
                            :value="false"
                          ></v-radio>
                          <v-radio
                            label="Joined Account (eg Account is with agency.)"
                            :value="true"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <!-- Display if user doesnt access-->
                      <v-col cols="12" v-if="noAccessMessage">
                        <p>
                          You currently do not have access to the Facebook page
                          in question. In order to gain access, we kindly
                          request that you reach out to the designated page
                          administrator. They possess the necessary permissions
                          and authority to grant you access to the page. Or
                          choose a different page.
                        </p>
                      </v-col>
                      <v-col cols="12"  v-if="packageTitle == 'Package 3' && noAccessMessage" class="text-center">
                        <v-btn
                          small
                          class="primary mx-auto"
                          rounded
                          @click="emailAdmins()"
                        >
                          Email Competitive Report
                        </v-btn>
                      </v-col>
                    </v-row>
                    <!-- Display if agency is Paid -->
                    <v-row>
                      <!-- Display Consent -->
                      <v-col
                        v-if="
                          (packageTitle === 'Package 1' &&
                            competitiveReportData) ||
                          (packageTitle === 'Package 3' &&
                            competitiveReportData) ||
                          (packageTitle === 'Package 2' && insightsReportData)
                        "
                        class="text-left"
                        cols="12"
                      >
                        <h4>
                          Consent*:
                          <a href="/terms-and-conditions">terms & conditions</a>
                        </h4>
                      </v-col>
                      <!-- Display terms & conditions -->
                      <v-col class="text-left py-0" cols="10">
                        <v-checkbox
                          v-if="
                            (packageTitle === 'Package 1' &&
                              competitiveReportData) ||
                            (packageTitle === 'Package 3' &&
                              competitiveReportData)
                          "
                          :rules="checkboxRules"
                          :disabled="packagePages.length < 2"
                          hide-details
                          label="I agree to the terms & conditions"
                          v-model="checkbox"
                          class="mt-0"
                        ></v-checkbox>
                        <v-checkbox
                          v-if="
                            packageTitle === 'Package 2' && insightsReportData
                          "
                          :rules="checkboxRules"
                          hide-details
                          label="I agree to the terms & conditions"
                          v-model="checkbox"
                          class="mt-0"
                        ></v-checkbox>
                      </v-col>
                      <!-- Tool tip to make sure user adds atleast 2 pages -->
                      <v-col
                        cols="2"
                        v-if="
                          packageTitle == 'Package 1' ||
                          packageTitle == 'Package 3'
                        "
                        class="text-right py-0"
                      >
                        <v-tooltip bottom v-if="packagePages.length < 2">
                          <template #activator="{ on }">
                            <v-icon v-on="on" class="icon-with-tooltip"
                              >mdi-comment-question-outline</v-icon
                            >
                          </template>
                          <span
                            >You need at least 1 competitor page to
                            continue.</span
                          >
                        </v-tooltip>
                      </v-col>
                      <v-col
                        v-if="
                          !noAccessMessage &&
                          this.$store.state.agency.agencyType != 'CompEatBeta'
                        "
                        cols="12"
                        class="text-center"
                      >
                        <v-btn
                          v-if="
                            packageTitle == 'Package 3' && insightsReportData
                          "
                          @click="generateInsightsReportNow()"
                          small
                          :disabled="!packageOnevalid"
                          class="primary"
                          rounded
                          >Continue With Package 3</v-btn
                        >
                      </v-col>
                      <v-col
                        v-if="
                          (packageTitle == 'Package 1' &&
                            competitiveReportData) ||
                          (packageTitle == 'Package 3' &&
                            competitiveReportData) ||
                          (packageTitle == 'Package 2' && insightsReportData)
                        "
                        cols="12"
                        class="text-center continue-button"
                      >
                        <v-btn
                          small
                          :disabled="!packageOnevalid"
                          class="primary"
                          rounded
                          @click="checkIfUserExist()"
                          >Continue</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" mb="4" lg="4">
          <v-img
            v-if="
              packageTitle == 'Package 1' &&
              this.$store.state.loggedIntoFacebook
            "
            src="../assets/packagepic1.png"
            width="300px"
            class="mx-auto"
          ></v-img>
          <v-img
            v-if="
              packageTitle == 'Package 2' &&
              this.$store.state.loggedIntoFacebook
            "
            src="../assets/packagepic3.png"
            width="300px"
            class="mx-auto"
          ></v-img>
          <v-img
            v-if="
              packageTitle == 'Package 3' &&
              this.$store.state.loggedIntoFacebook
            "
            src="../assets/packagepic2.png"
            width="300px"
            class="mx-auto"
          ></v-img>
          <v-img
            v-if="
              this.$store.state.loggedIntoFacebook &&
              demoPackage &&
              !selectReportType
            "
            width="300px"
            class="mx-auto"
            src="../assets/packagepic4.png"
          ></v-img>
          <v-card class="cardsradius" v-if="demoPackage && !selectReportType">
            <v-card-text>
              <v-row>
                <v-col cols="12" class="text-center">
                  <h1 class="steptext">Welcome to CompEat</h1>
                  <v-divider class="mt-4"></v-divider>
                </v-col>
                <v-col cols="12" class="text-center">
                  <h3 class="bold mb-4">
                    Discover the power of insights and competitive analysis with our Free Demo Report – no credit card details required.
                  </h3>
                  <p>Simply log in securely to your Facebook account to access your report:</p>
                  <ol class="mb-4">
                    <li>
                      Facebook Competitive Analysis: Compare your business page performance against your competitors side-by-side.
                    </li>
                    <li>
                      Facebook & Instagram Analytics: Dive into paid ad analytics for strategic decision-making and cost savings.
                    </li>
                    <li>
                      Comprehensive Package: Combine competitive analysis and in-depth marketing analytics for both organic and paid strategies.
                    </li>
                  </ol>
                  <p>
                    Please ensure you have access to your Facebook page and Ad account for Packages 2 and 3.
                  </p>
                  <p>Let's collaboratively unlock the potential of data-driven decisions for your business!</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="cardsradius" v-if="packageTitle">
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  class="text-center"
                  v-if="packageTitle && !demoPackage"
                >
                  <h1 class="steptext">{{ packageTitle }}</h1>
                  <v-divider class="mt-4"></v-divider>
                </v-col>
                <v-col
                  cols="12"
                  class="text-center"
                  v-if="demoPackage && packageTitle"
                >
                  <h1 class="steptext">Demo {{ packageTitle }}</h1>
                  <v-divider class="mt-4"></v-divider>
                </v-col>
                <v-col cols="12" class="text-center" v-if="!demoPackage">
                  <h1 class="steptext compeatsecondary--text mb-4">
                    ${{ computedPriceTotal }} /Mo
                  </h1>
                  <h3
                    v-if="
                      packageTitle == 'Package 1' ||
                      packageTitle == 'Package 2' ||
                      packageTitle == 'Package 3'
                    "
                    class="steptext"
                  >
                    ${{ computedPriceTotal }} per month.
                  </h3>
                  <v-divider class="mt-4"></v-divider>
                </v-col>
                <v-col cols="12" class="text-center py-0">
                  <v-list dense>
                    <v-list-item-group color="frontendblue">
                      <v-list-item
                        v-if="
                          packageTitle == 'Package 1' ||
                          packageTitle == 'Package 3'
                        "
                      >
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Generate A Competitor Analysis Report
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          packageTitle == 'Package 1' ||
                          packageTitle == 'Package 3'
                        "
                      >
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-if="
                              (packageTitle == 'Package 1' && !demoPackage) ||
                              (packageTitle == 'Package 3' && !demoPackage)
                            "
                          >
                            Competitors: Up To 4
                          </v-list-item-title>
                          <v-list-item-title
                            v-if="
                              (packageTitle == 'Package 1' && demoPackage) ||
                              (packageTitle == 'Package 3' && demoPackage)
                            "
                          >
                            Competitors: Up to 50
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (packageTitle == 'Package 1' && !demoPackage) ||
                          (packageTitle == 'Package 3' && !demoPackage)
                        "
                      >
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            $10 per Additional Competitor
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="packageTitle == 'Package 3'">
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Facebook and Instagram Analytics
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="packageTitle == 'Package 2'">
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Facebook Analytics Report
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="packageTitle == 'Package 2'">
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Instgram Analytics Report
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (packageTitle == 'Package 1' && !demoPackage) ||
                          (packageTitle == 'Package 2' && !demoPackage) ||
                          (packageTitle == 'Package 3' && !demoPackage)
                        "
                      >
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Monthly Scheduled Reports
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          packageTitle == 'Package 2' ||
                          packageTitle == 'Package 3'
                        "
                      >
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Performance Insights
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (packageTitle == 'Package 1' && demoPackage) ||
                          (packageTitle == 'Package 2' && demoPackage) ||
                          (packageTitle == 'Package 3' && demoPackage)
                        "
                      >
                        <v-list-item-icon>
                          <v-icon color="frontendblue">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Report Links Will Be Emailed
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="120">
          <p class="mb-0 overlaytext">Please Wait...</p>
        </v-progress-circular>
      </v-overlay>
      <v-overlay :value="redirecting">
        <v-progress-circular indeterminate size="120">
          <p class="mb-0 overlaytext">Please Wait <br />redirecting...</p>
        </v-progress-circular>
      </v-overlay>
      <v-overlay v-if="overlayBusyGeneratingReport">
        <v-card class="px-4 py-4 generatingreportcard" light>
          <v-card-text class="pt-5">
            <v-row>
              <v-col cols="12" class="text-center">
                <h2
                  v-if="
                    (packageTitle == 'Package 1' &&
                      generateCompetitiveAnalysisReportPopup == true) ||
                    (packageTitle == 'Package 3' &&
                      generateCompetitiveAnalysisReportPopup == true)
                  "
                  class="compeatfont"
                >
                  Busy Generating Competitive <br />Analysis Report.<br />
                  Please be patient.
                </h2>
                <h2
                  v-if="
                    (packageTitle == 'Package 2' &&
                      generatingFacebookInsightsReport == true) ||
                    (packageTitle == 'Package 3' &&
                      generatingFacebookInsightsReport == true)
                  "
                  class="compeatfont"
                >
                  Busy Generating FaceBook <br />
                  Insights Report. <br />Please be patient.
                </h2>
                <h2
                  v-if="
                    (packageTitle == 'Package 2' &&
                      generatingInstgramInsightsReport == true) ||
                    (packageTitle == 'Package 3' &&
                      generatingInstgramInsightsReport == true)
                  "
                  class="compeatfont"
                >
                  Busy Generating Instagram<br />
                  Insights Report. <br />Please be patient.
                </h2>
                <h2
                  v-if="
                    (packageTitle == 'Package 1' && emailingClient == true) ||
                    (packageTitle == 'Package 2' && emailingClient == true) ||
                    (packageTitle == 'Package 3' && emailingClient == true)
                  "
                  class="compeatfont"
                >
                  Emails are being generated now.
                </h2>
              </v-col>
              <v-col cols="12" class="text-center hidding-md-and-down">
                  <iframe
                    width="100%"
                    height="200"
                    src="https://www.youtube.com/embed/HS9DdokWJEg?autoplay=1"
                    title="CompEat Demo Video"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
              </v-col>
              <v-col class="col-12 black--text text-center">
                <v-progress-linear
                  class="my-3"
                  color="compeatsecondary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
                <p class="mb-0">Please wait...</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-overlay>
      <v-overlay :value="overlayError">
        <v-card width="400px" light class="px-4 py-4 mx-4 mycardradius">
          <v-row>
            <v-col class="col-12 black--text text-center">
              <!-- <v-icon size="50" color="compeatsecondary"
                  >mdi-alert-circle</v-icon
                > -->
              <v-img src="../assets/error.png" width="300" class="mx-auto" />
              <p class="body-1 mb-0">Oops something went wrong.</p>
              <p class="body-1">{{ this.catchErrorMessage }}</p>
              <v-btn
                v-if="regenerateCompetitive || regenerateFacebookInsights"
                class="frontendblue white--text mr-2"
                rounded
                small
                @click="contactSupport()"
                >Support</v-btn
              >
              <v-btn
                v-if="regenerateCompetitive"
                class="frontendblue white--text mr-2"
                rounded
                small
                @click="regenerateCompetitiveReport()"
                >Try Again</v-btn
              >
              <v-btn
                v-if="regenerateFacebookInsights"
                class="frontendblue white--text mr-2"
                rounded
                small
                @click="regenerateFacebookInsightsReport()"
                >Try Again</v-btn
              >

              <v-btn
                v-else
                icon
                color="frontendblue white--text"
                @click="cancelError()"
              >
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-overlay>
      <v-overlay :value="overlayPaymentMethodError">
        <v-card width="400px" light class="px-4 py-4 mx-4 mycardradius">
          <v-row>
            <v-col class="col-12 black--text text-center">
              <!-- <v-icon size="50" color="compeatsecondary"
                  >mdi-alert-circle</v-icon
                > -->
              <v-img src="../assets/error.png" width="300" class="mx-auto" />
              <p class="body-1 mb-0">Oops something went wrong.</p>
              <p class="body-1">{{ this.catchErrorMessage }}</p>
              <v-btn
                icon
                color="frontendblue white--text"
                @click="cancelError()"
              >
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        {{ this.$store.state.user.facebookToken }}
      </v-overlay>
      <v-overlay v-if="paymentResponseDialog">
        <!-- testing -->
        <v-card class="px-4 py-4 generatingreportcard" light>
          <v-card-text class="pt-5">
            <v-row v-if="paymentResponse == true">
              <v-col cols="12" class="text-center">
                <!-- mdi-emoticon-happy -->
                <v-avatar size="80px" class="compeatsecondary">
                  <v-icon color="white" size="50px"> mdi-check-circle </v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="12" class="text-center">
                <h2 class="compeatsecondary--text compeatfont mb-3">
                  Payment Was Successfull
                </h2>
                <p class="mb-0">
                  Please wait...
                </p>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" class="text-center">
                <!-- mdi-emoticon-happy -->
                <v-avatar size="80px" class="compeatsecondary">
                  <v-icon color="white" size="50px"> mdi-alert-circle </v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="12" class="text-center">
                <h2 class="compeatsecondary--text compeatfont mb-3">
                  Payment Was unsuccessfull
                </h2>
                <p>
                  You did not complete the purchase.
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-overlay>
      <v-overlay v-if="displayContinue">
        <!-- testing -->
        <v-card class="px-4 py-4 generatingreportcard" light>
          <v-card-text class="pt-5">
            <v-row>
              <v-col cols="12" class="text-center">
                <!-- mdi-emoticon-happy -->
                <v-avatar size="80px" class="compeatsecondary">
                  <v-icon color="white" size="50px"> mdi-check-circle </v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="12" class="text-center">
                <h2 class="compeatsecondary--text compeatfont mb-3">
                  Thanks for your payment.
                </h2>
                <p>Now its time to generate your report. Please click on the continue button below to complete your purchase.</p>
                <v-btn 
                  v-if="this.packageTitle == 'Package 1' || this.packageTitle == 'Package 3'"
                  small
                  class="primary py-3"
                  rounded
                  @click="createReport()"
                >
                  Generate Report
                </v-btn>
                <v-btn 
                  v-if="this.packageTitle == 'Package 2'"
                  small
                  class="primary py-3"
                  rounded
                  @click="generateInsightsReportNow()"
                >
                  Generate Report
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-overlay>
      <v-overlay v-if="displayCancelled">
        <!-- testing -->
        <v-card class="px-4 py-4 generatingreportcard" light>
          <v-card-text class="pt-5">
            <v-row>
              <v-col cols="12" class="text-center">
                <!-- mdi-emoticon-happy -->
                <v-avatar size="80px" class="compeatsecondary">
                  <v-icon color="white" size="50px">mdi-alert-circle </v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="12" class="text-center" v-if="!reason">
                <!-- reason -->
                <h2 class="compeatsecondary--text compeatfont mb-3">
                  Payment Cancelled
                </h2>
                <p class="mb-0">We regret to inform you that your payment has been cancelled, thus preventing the continuation of your subscription purchase.</p>
                <p> If there is anything we can assist you with or if you require further assistance, please do not hesitate to contact our support team.</p>
              </v-col>
              <v-col cols="12" class="text-center" v-if="reason">
                <!-- reason -->
                <h2 class="compeatsecondary--text compeatfont mb-3">
                 Sorry To See You Go
                </h2>
                <p class="mb-0">Your feedback is valuable to us as we strive to enhance our service for all our subscribers. </p>
              </v-col>
              <v-col cols="12" sm="12" v-if="reason" class="text-center">
                <v-text-field
                  class="pt-0"
                  v-model="reasonForLeaving"
                  label="Reason (optional)"
                  :rules="textRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="!reason" class="text-center">
                <v-btn 
                  small
                  class="primary py-3 mr-1"
                  rounded
                  @click="anotherTime()"
                >
                 Another Time
                </v-btn>
                <v-btn
                  small
                  class="primary py-3 ml-1"
                  rounded
                  @click="proceedToCheckOut()"
                  >Retry Payment</v-btn>
              </v-col>
              <v-col cols="12" v-if="reason" class="text-center">
                <v-btn 
                  small
                  class="primary py-3"
                  rounded
                  @click="cancelledSubscriptionPayment()"
                >
                 Continue
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-overlay>
      <v-overlay v-if="tooManyDemoReports">
        <v-card class="px-4 py-4 generatingreportcard" light>
          <v-card-text class="pt-5">
            <v-row>
              <v-col cols="12" class="text-center">
                <v-avatar size="80px" class="compeatsecondary">
                  <v-icon color="white" size="50px"> mdi-check-circle </v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="12" class="text-center">
                <h2 class="compeatsecondary--text compeatfont mb-3">
                  Sorry demo report limit exceeded.
                </h2>
                <p>You have generated 3 demo reports already. You will need to purchase a package to get a report now.</p>
                <v-btn 
                  small
                  class="primary py-3"
                  rounded
                  @click="goToPackages()"
                >
                  Packages
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import generalAlert from "../components/alerts/generalAlert.vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../firebaseConfig";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  deleteDoc,
  setDoc
} from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default {
  components: {
    generalAlert,
  },
  props: ["title", "demoReportId", "url"],
  data: () => ({
    //Test varibles
    items: [
      { text: "Real-Time", icon: "mdi-clock" },
      { text: "Audience", icon: "mdi-account" },
      { text: "Conversions", icon: "mdi-flag" },
    ],

    // packages for v-select
    packages: [
      {
        name: "Package 1 (FB Competitive Analysis.)",
        value: "CAO",
      },
      {
        name: "Package 2 (FB and IG Insights Only)",
        value: "ISO",
      },
      {
        name: "Package 3 (FB Competitive Analysis, FB and IG Insights)",
        value: "CAIS",
      },
    ],
    selectReportType: "",

    //Package varibles
    plan: "",
    plan2: "",
    quantity: 0,
    packageTitle: "",
    priceTotal: 0,
    pagesToAdd: 5,
    packagePages: [],
    competitiveReportData: false,
    insightsReportData: false,
    overlayBusyGeneratingReport: false,
    checkingForInstagramAccess: false,
    generatingInstgramInsightsReport: false,

    //Package 1 form v-model
    packageOnevalid: false,

    // packageTwoValid: false,
    packageThreeValid: false,

    //form fields
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    checkbox: false,

    //emails
    emailingClient: false,
    newUser: false,

    //Agency Varibles
    agencyId: "",
    agencyProfile: [],

    //Rules for fields
    textRules: [(v) => !!v || "Field is required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    checkboxRules: [
      (v) => !!v || "I agree to the terms & conditions must be checked",
    ],

    //Company Search field
    search: "",
    loadingSearch: false,
    searchResults: [],
    loadingTimer: null,
    focus: false,

    //search Error
    searchPageError: false,
    searchErrorMessage: "",

    //Facebook insights report data
    checkingForAccess: false,
    hasAccess: false,
    adAccountId: "",
    adsAccountsForPage: [],
    noAccessMessage: false,
    adsAccountId: "",
    generatingFacebookInsightsReport: false,
    singlePage: null,
    primaryPageToken: "",

    //User data for subscription
    currentSubscriberId: [],
    password: "",

    //loading overlay
    overlay: false,

    //overlay for error creating user
    absolute: true,
    overlayError: false,
    catchErrorMessage: "",

    //new subscription price
    subscriptionPrice: "",
    newSubscription: [],
    newSubscriptionUid: "",
    reportType: "",

    //payment varibles
    paymentResponseDialog: false,
    overlayPaymentMethodError: false,
    loading: false,

    //success or error varibles
    alert: false,
    alertType: "",
    successResponse: "",

    //report varibles
    competitiveReportUid: "",
    facebookInsightsReportUid: "",
    instagramInsightsReportUid: "",

    //generate report varibles for overlay
    generateCompetitiveAnalysisReportPopup: false,

    //redirecting to thank you page
    redirecting: false,

    //facebook varibles
    facebookLoginLoading: false,
    cancelledLogin: false,
    userToken: "",

    //errors in generating report
    regenerateCompetitive: false,
    regenerateFacebookInsights: true,

    //Display once returned back from paypal
    displayContinue:false,
    displayCancelled:false,

    //Display tooManyDemoReports
    tooManyDemoReports:false,

    reason:false,
    reasonForLeaving:'',

    extendedToken: "",
    subscriptionPersonalInfo: true,
    demoPackage: false,
    packageType: "",
    coupon: "",
    plan_id: "",
  }),
  //facebook SDK
  mounted() {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.fbAsyncInit = function () {
      FB.init({
        appId: "736605293879783",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v16.0",
      });
    };
  },
  created() {
    this.overlay = true;
    let defaultAgencyId = "S83EWuzohPa3tVb98qjT";
    if (this.demoReportId && this.url) {
      this.decryptUrl();
    } else if (this.$store.state.frontEndSubscription.name) {
      this.checkSuccess();
    } else {
      if (this.title == "package-1") {
        this.package1();
      } else if (this.title == "package-2") {
        this.package2();
      } else if (this.title == "package-3") {
        this.package3();
      } else if (this.title == "package-demo") {
        this.demoPackage = true;
      }
      this.getAgencyInfo(defaultAgencyId);
    }
  },
  computed: {
    // dynamic labling for the search field
    dynamicLabel() {
      if (this.packagePages.length !== 0) {
        return "Competitor pages";
      } else if (this.packagePages.length == 0 && this.packageTitle == "Package 1" || this.packagePages.length == 0 && this.packageTitle == "Package 2" || this.packagePages.length == 0 && this.packageTitle == "Package 3") {
        return "Your Facebook Page";
      }
    },
    // checks which package and then determins the price
    computedPriceTotal() {
      if (this.packageTitle === "Package 2") {
        return this.priceTotal;
      } else if (
        this.packageTitle === "Package 1" ||
        this.packageTitle === "Package 3"
      ) {
        const extraUnits = Math.max(this.packagePages.length - 5, 0);
        const extraPrice = extraUnits * 10;
        return this.priceTotal + extraPrice;
      }
    },
    //Validationg for the select signle page
    singlePageValidation() {
      return this.singlePage === null ? "Please select an option" : true;
    },
  },
  methods: {
    //Ga4 tracking for begin_checkout
    // ga4BeginCheckOut() {
    //   this.$gtag.event('begin_checkout', {
    //     event_category: 'user_engagement', // optional
    //     event_label: 'begin_checkout' ,// optional
    //     value:this.subscriptionPrice
    //     // ecommerce_value:this.subscriptionPrice,
    //     // ecommerce_currency:'USD',
    //     // ecommerce_products:this.packageTitle
    //   })

    //   if(this.displayCancelled != true){
    //     this.createPaypalSubscription();
    //   }else {
    //    this.proceedToCheckOut()
    //   }
    // },
    moveToAnchor() {
      const anchorElement = document.getElementById("anchor");
      if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: "smooth" });
      }
    },
    //Logs user in with facebook SDK
    loginWithFacebook() {
      this.facebookLoginLoading = true;
      //incase user did cancel the login process
      this.cancelledLogin = false;
      FB.login(
        (response) => {
          if (response.authResponse) {
            this.userToken = response.authResponse.accessToken;
            this.extendUserFacebookToken(response.authResponse.accessToken);
          } else {
            this.cancelledLogin = true;
            this.overlay = false;
            this.facebookLoginLoading = false;
            // this.loading = false
          }
        },
        {
          scope:
            "read_insights, pages_show_list, ads_management, ads_read, page_events, pages_read_engagement, pages_read_user_content, public_profile, instagram_basic, instagram_manage_insights",
        }
      );
    },
    //extend the facebook token
    async extendUserFacebookToken(token) {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const extendAccessToken = httpsCallable(functions, "extendAccessToken");

      extendAccessToken({
        token: token,
      }).then((result) => {
        this.extendedToken = result.data.response;
        this.checkTokenValid(this.extendedToken);
      });
    },
    //Gets agency info if client has been cleared with facebook verification
    async getAgencyInfo(id) {
      try {
        const docRef = doc(db, "agencies", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          this.agencyProfile = docSnap.data();
          this.$store.commit("setAgency", this.agencyProfile);
          if (this.$store.state.facebookToken != "") {
            this.checkTokenValid(this.$store.state.facebookToken);
          } else {
            this.$store.commit("setloggedIntoFacebook", false);
            this.overlay = false;
          }
        } else {
          console.log("No such document!");
          this.overlay = false;
        }
      } catch (err) {
        console.log("getAgencyInfo err", err);
        this.overlay = false;
      }
    },
    //check facebook token
    checkTokenValid(token) {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const checkIfTokenIsValid = httpsCallable(
        functions,
        "checkIfTokenIsValid"
      );
      checkIfTokenIsValid({
        token: token,
      })
        .then((result) => {
          if (result.data.response.valid) {
            this.$store.commit("setloggedIntoFacebook", true);
            this.$store.commit("setUserToken", token);
            this.extendedToken = token;
            this.facebookLoginLoading = false;
          }
          this.overlay = false;
        })
        .catch((err) => {
          console.log(err);
          this.$store.commit("setloggedIntoFacebook", false);
          this.overlay = false;
        });
    },
    //logout facebook
    logoutFromFacebook() {
      this.overlay = true;
      let token = "";
      this.$store.commit("setloggedIntoFacebook", false);
      this.$store.commit("setUserToken", token);
      FB.getLoginStatus((response) => {
        if (response.status === "connected") {
          var accessToken = response.authResponse.accessToken;
          FB.logout(
            function (response) {
              console.log("logout", response);
            },
            { access_token: accessToken }
          );
        }
      });
      this.overlay = false;
    },
    //decrypt the url
    decryptUrl() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const decryptUrl = httpsCallable(functions, "decryptUrl");

      decryptUrl({
        url: this.url,
        agencyId: this.demoReportId,
      })
        .then((result) => {
          const params = new URLSearchParams(result.data.response);

          this.firstName = params.get("firstName");
          this.lastName = params.get("lastName");
          this.email = params.get("email");
          this.agencyId = params.get("agency");
          this.coupon = params.get("coupon");

          if (this.title == "package-1") {
            this.package1();
          } else if (this.title == "package-2") {
            this.package2();
          } else if (this.title == "package-3") {
            this.package3();
          }

          this.getAgencyInfo(this.agencyId);
        })
        .catch((error) => {
          console.log(error);
          this.searchPageError = true;
          this.searchErrorMessage = "Something went wrong please try again";
        });
    },
    checkSuccess() {
        const queryString = this.$route.fullPath.split('?')[1];
        if (queryString) {
            const params = new URLSearchParams(queryString);
            const successValue = params.get('success');
            if (successValue === 'true') {
              console.log('true', successValue)
              this.overlay = false;
              this.paymentResponse = true;
              this.paymentResponseDialog = true;
              setTimeout(() => {
                this.paymentResponse = false;
                this.paymentResponseDialog = false;
                this.getSubscriptionDataFromStore(successValue)
              }, 3000);
              console.log('true')
                // return true;
            }else {
              console.log('false', successValue)
              this.overlay = false;
              this.paymentResponse = false;
              this.paymentResponseDialog = true;
              setTimeout(() => {
                this.paymentResponse = false;
                this.paymentResponseDialog = false;
                this. getSubscriptionDataFromStore(successValue)
              }, 3000);
            }
        }
        // return false;
    },
    //get Subscription Data from store one payment successful
    getSubscriptionDataFromStore(successValue) {
    
        const fullName = this.$store.state.frontEndSubscription.name;

        // Split the full name into an array of first name and last name
        const [firstName, lastName] = fullName.split(" ");

        // Assign the first name and last name to the variables
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = this.$store.state.frontEndSubscription.email;
        this.mobile = this.$store.state.frontEndSubscription.mobile;
        this.packagePages = this.$store.state.frontEndSubscription.package.pages;
        this.packageTitle = this.$store.state.frontEndSubscription.package.currentPackage
        this.newSubscriptionUid = this.$store.state.frontEndSubscription.uid;
        this.newSubscription = this.$store.state.frontEndSubscription
        this.newUser = this.$store.state.newUser
        this.password = this.$store.state.newUserPassword

        this.primaryPageId = this.$store.state.insightsData.primaryPageId;
        this.adsAccountId = this.$store.state.insightsData.adAccountId;
        this.primaryPageToken = this.$store.state.insightsData.pageToken;
        this.singlePage = this.$store.state.insightsData.singlePage;
        this.hasAccess = this.$store.state.hasAccess

        this.agencyProfile = this.$store.state.agency

      if (this.title == "package-1") {
        this.package1()
          // this.redirectPackage1()
        } else if (this.title == "package-2") {
          this.package2()
          // this.redirectPackage2()
        } else if (this.title == "package-3") {
          this.package3()
        // this.redirectPackage3()
        }

        let items = [
                {
                  index:0,
                  affiliation: "CompEat Social",
                  item_name: this.packageTitle,
                  item_brand: "CompEat",
                  item_category: "Packages",
                  item_variant: this.packageTitle,
                  price: this.newSubscription.package.priceTotal,
                  quantity: this.newSubscription.package.quantity
                }
              ]

        consooe.log('items', items)

        if(successValue === 'true'){
          this.$gtag.event('purchase_successful', {
              event_category: 'user_engagement', // optional
              event_label: 'purchase_successful' ,// optional
              currency: 'USD',
              value: this.newSubscription.package.priceTotal,
                items: [
                {
                  index:0,
                  affiliation: "CompEat Social",
                  item_name: this.packageTitle,
                  item_brand: "CompEat",
                  item_category: "Packages",
                  item_variant: this.packageTitle,
                  price: this.newSubscription.package.priceTotal,
                  quantity: this.newSubscription.package.quantity
                }],
            })
          this.displayContinue = true
        }else if (successValue === null){
          this.$gtag.event('purchase_cancelled', {
              event_category: 'user_engagement', // optional
              event_label: 'purchase_cancelled' ,// optional
              currency: 'USD',
              value: this.subscriptionPrice,
                items: [
                {
                  index:0,
                  affiliation: "CompEat Social",
                  item_name: this.packageTitle,
                  item_brand: "CompEat",
                  item_category: "Packages",
                  item_variant: this.packageTitle,
                  price: this.newSubscription.package.priceTotal,
                  quantity: this.newSubscription.package.quantity
                }
              ],
            })
          this.displayCancelled = true
        }

    },
    // seach for company pages
    searchForCompany() {
      this.searchPageError = false;

      if (this.search.length < 2) {
        this.searchResults = [];
        this.loadingSearch = false; // No need to show loading for short queries
        return;
      }

      if (this.loadingTimer) {
        clearTimeout(this.loadingTimer); // Clear the previous timeout
      }

      this.loadingTimer = setTimeout(() => {
        this.loadingSearch = true; // Show loading after a delay
      }, 300); // Adjust the delay time as needed

      const functions = getFunctions(firebaseApp, "europe-west2");
      const searchFacebookPage = httpsCallable(functions, "searchFacebookPage");

      const currentSearchQuery = this.search;
      console.log("searchForCompany this.extendedToken", this.extendedToken);
      searchFacebookPage({
        query: this.search,
        fbToken: this.extendedToken,
      })
        .then((result) => {
          if (this.search === currentSearchQuery) {
            let searchpages = result.data.response.pageData;
            this.searchResults = [];
            this.searchResults.push(...searchpages);
            this.focus = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.searchPageError = true;
          this.searchErrorMessage = "Something went wrong please try again";
        })
        .finally(() => {
          clearTimeout(this.loadingTimer); // Clear the timeout
          this.loadingSearch = false;
        });
    },
    // Adds pages to packagePages array and changes searchResults to false
    selectCompany(facebookpage) {
      this.packagePages.push(facebookpage);
      this.searchResults = [];
      this.search = "";
      this.focus = false;
    },
    // Adds pages to packagePages array and changes searchResults to false for insights
    selectInsightsCompany(facebookpage) {
      this.packagePages.push(facebookpage);
      this.searchResults = [];
      this.search = "";
      this.focus = false;
      this.checkForPageAccess();
      this.noAccessMessage = false;
      this.checkingForAccess = true;
    },
    //Check primary page to see if you have access for the facebook insights reports
    checkForPageAccess() {
      let facebookToken = "";

      if (this.$store.state.facebookToken != "") {
        facebookToken = this.$store.state.facebookToken;
      } else if (this.$store.state.user.facebookToken != "") {
        facebookToken = this.$store.state.facebookToken;
      }

      const functions = getFunctions(firebaseApp, "europe-west2");
      const getPageToken = httpsCallable(functions, "getPageToken");

      getPageToken({
        userToken: facebookToken,
        pageId: this.packagePages[0].id,
      }).then((result) => {
        this.primaryPageToken = result.data.response;
        if (this.primaryPageToken == "") {
          this.noAccessMessage = true;
          this.checkingForAccess = false;
          this.hasAccess = false;
          this.overlay = false;
        } else {
          this.getAdsAccountsForPage();
        }
      });
    },
    //Gets ads account for the current logged in user from facebook
    getAdsAccountsForPage() {
      let facebookToken = "";

      if (this.$store.state.facebookToken != "") {
        facebookToken = this.$store.state.facebookToken;
      } else if (this.$store.state.user.facebookToken != "") {
        facebookToken = this.$store.state.facebookToken;
      }

      const functions = getFunctions(firebaseApp, "europe-west2");
      const getAdAccountId = httpsCallable(functions, "getAdAccountId");

      getAdAccountId({
        userToken: facebookToken,
      }).then((result) => {
        let array = result.data.response;

        let emptyItem = {
          name: "No Ad Account For Page",
          id: "0",
          account_id: "",
        };

        array.unshift(emptyItem);

        this.adsAccountsForPage = array;
        setTimeout(() => {
          this.checkingForAccess = false;
          this.hasAccess = true;
          this.$store.commit("setHasAccess", this.hasAccess);
          this.overlay = false;
        }, 2000);
      });
    },
    //Step 1
    // Gets if user email is in our system
    async checkIfUserExist() {
      this.overlay = true;
      const q = query(
        collection(db, "users"),
        where("email", "==", this.email)
      );
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty == true) {
        console.log("New User");
        this.newUser = true;
        this.$store.commit("setIfNewUser", this.newUser);
        this.createNewFirebaseUser();
      } else {
        console.log("Already A user");
        this.newUser = false;
        this.$store.commit("setIfNewUser", this.newUser);
        querySnapshot.forEach(async (doc) => {
            let user = {
              data: {
                userId: doc.data().id,
              }
            };

            this.currentSubscriberId = user;

            if(this.demoPackage) {
              let subscriptions = []
              const subscriptionQuery = query(
                collection(db, "subscriptions"),
                where("subscriberId", "==", this.currentSubscriberId.data.userId),
                where("package.packageType", "==", "Compeat Demo Subscription")
              );
              const subscriptionQuerySnapshot = await getDocs(subscriptionQuery);
              
              subscriptionQuerySnapshot.forEach(subscriptionDoc => {
                const subscription = subscriptionDoc.data();
                subscriptions.push(subscription)
              });

              if(subscriptions.length < 3) {
                console.log("User does not have more than 3 Compeat Demo Subscriptions");
                this.createSubscription(this.currentSubscriberId);
              }else {
                console.log("User has more than 3 Compeat Demo Subscriptions");
                this.tooManyDemoReports = true
              }

              console.log('subscriptions', subscriptions)
            }else {
              this.createSubscription(this.currentSubscriberId);
            }
            
        });
      }
    },
    //Generate password for new Subscriber
    generateRandomPassword() {
      const length = 12;
      const charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let newPassword = "";

      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        newPassword += charset.charAt(randomIndex);
      }

      this.password = newPassword
      console.log('setNewUserPassword',this.password )
      this.$store.commit("setNewUserPassword", this.password);

      return this.password
    },
    //Create New User in firebase
    createNewFirebaseUser() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const createSubscriptionUser = httpsCallable(
        functions,
        "createSubscriptionUser"
      );

      createSubscriptionUser({
        name: this.firstName + " " + this.lastName,
        email: this.email,
        password: this.generateRandomPassword(),
        mobile: this.mobile,
        userType: "SB",
        agency: this.agencyProfile.agencyId,
        facebookToken: "",
      })
        .then((result) => {
          console.log("createSubscriptionUser.result", result);
          if (
            result.data.httpErrorCode != null &&
            result.data.httpErrorCode.status == 500
          ) {
            this.overlay = false;
            this.overlayError = true;
            this.catchErrorMessage = result.data.response.httpErrorCode.status;
          } else {
            // this.currentSubscriber = result.data.response;
            let user = {
              data: {
                userId: result.data.response.userId,
              },
            };
            this.createSubscription(user);
            // this.createSubscription(this.currentSubscriber);
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.overlay = false;
          this.overlayError = true;
          this.catchErrorMessage =
            error.message + " Please check all fields are correct";
        });
    },
    //Step 2 if user exists in firebase
    //Step 3 after creating new firebase user
    // Creates subscription via Cloud function
    async createSubscription(user) {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const createSubscription = httpsCallable(functions, "createSubscription");
      this.packageType = this.agencyProfile.agencyType;

      const planIds = {
        "Package 1": {
          lessThanFive: "P-51K86037JT627370VM2LHP6Y",
          moreThanFive: "P-4HF68781BE388245DM2LHRQY",
        },
        "Package 2": "P-4LT47173CY685383TM2LWHRQ",
        "Package 3": {
          lessThanFive: "P-8SX24665D9801100WM2LWIVQ",
          moreThanFive: "P-5HH45303H9196381CM2LWJLI",
        },
      };

    switch (this.packageTitle) {
        case "Package 1":
            if (this.packagePages.length < 5) {
              this.subscriptionPrice = this.priceTotal;
              this.quantity = 1;
              this.plan_id = planIds["Package 1"].lessThanFive;
            } else {
              const extraUnits = this.packagePages.length - 5;
              const extraQuantity = extraUnits
              const extraPrice = extraUnits * 10;
              this.subscriptionPrice = this.priceTotal + extraPrice;
              this.quantity = 1 + extraQuantity
              this.plan_id = planIds["Package 1"].moreThanFive;
            }
            break;
        case "Package 2":
            this.subscriptionPrice = this.priceTotal;
            this.quantity = 1;
            this.plan_id = planIds["Package 2"];
            break;
        case "Package 3":
            if (this.packagePages.length < 5) {
              this.subscriptionPrice = this.priceTotal;
              this.quantity = 1;
              this.plan_id = planIds["Package 3"].lessThanFive;
            } else {
              const extraUnits = this.packagePages.length - 5;
              const extraQuantity = extraUnits
              const extraPrice = extraUnits * 10;
              this.subscriptionPrice = this.priceTotal + extraPrice;
              this.quantity = 1 + extraQuantity
              this.plan_id = planIds["Package 3"].moreThanFive;
            }
            break;
    }

      if (this.demoPackage) {
        this.packageType = "Compeat Demo Subscription";
      }

      createSubscription({
        name: this.firstName + " " + this.lastName,
        mobile: this.mobile,
        email: this.email,
        subscriberId: user.data.userId,
        userType: "Subscriber",
        package: {
          currentPackage: this.packageTitle,
          primaryPage: this.packagePages[0],
          pages: this.packagePages,
          quantity: this.quantity,
          priceTotal: this.subscriptionPrice,
          packageType: this.packageType,
        },
        agencyId: this.agencyProfile.agencyId,
        agencyName: this.agencyProfile.agencyName,
        agencyLogo: this.agencyProfile.agencyLogo,
        agencyUser: "",
        dateCreated: Date.now(),
        isActive: true,
        paymentStatus: "Pending",
      })
        .then((result) => {
          console.log("createSubscription", result);
          //old
          this.newSubscription = result.data.response.data;
          this.newSubscriptionUid = result.data.response.data.uid;

          if (
            (this.packageTitle == "Package 1" &&
              this.agencyProfile.agencyType == "CompEatBeta") ||
            (this.packageTitle == "Package 3" &&
              this.agencyProfile.agencyType == "CompEatBeta") ||
            (this.packageTitle == "Package 1" && this.demoPackage) ||
            (this.packageTitle == "Package 3" && this.demoPackage)
          ) {
            // this.getClientPaymentMethod();
            this.overlayBusyGeneratingReport = true;
            this.generateCompetitiveAnalysisReportPopup = true;
            this.createReport();
          } else if (
            (this.packageTitle == "Package 3" &&
              this.agencyProfile.agencyType == "CompEatBeta") ||
            (this.packageTitle == "Package 2" && this.demoPackage)
          ) {
            //this.getClientPaymentMethod();
            this.overlayBusyGeneratingReport = true;
            this.generateInsightsReportNow();
          } else if (
            (this.packageTitle == "Package 1" &&
              this.agencyProfile.agencyType != "CompEatBeta") ||
            (this.packageTitle == "Package 3" &&
              this.agencyProfile.agencyType != "CompEatBeta")
          ) {
            this.overlay = false;
            this.redirecting = true;
            this.$store.commit("setFrontEndSubscription", this.newSubscription);
            this.$gtag.event('begin_checkout', {
              event_category: 'user_engagement',
              event_label: 'begin_checkout' ,
              value: this.subscriptionPrice,
            })
            this.createPaypalSubscription()
          } else if (
            this.packageTitle == "Package 2" &&
            this.agencyProfile.agencyType != "CompEatBeta"
          ) {
            this.overlay = false;
            this.redirecting = true;
            this.$store.commit("setInsightsData", {
              pageToken: this.primaryPageToken,
              primaryPageId: this.packagePages[0].id,
              agencyId: this.agencyProfile.agencyId,
              subscriptionId: this.newSubscriptionUid,
              adAccountId: this.adsAccountId,
              singlePage: this.singlePage, // or false, depending on your requirement
            });
            this.$store.commit("setFrontEndSubscription", this.newSubscription);
            this.$gtag.event('begin_checkout', {
              event_category: 'user_engagement',
              event_label: 'begin_checkout' ,
              value: this.subscriptionPrice,
            })
            this.createPaypalSubscription()
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.overlay = false;
          this.overlayError = true;
          this.catchErrorMessage =
            error.message +
            ". Please check all fields are filled in with the correct info. If you still having a problem please contact support.";
        });
    },
    //Generated the checkout page for paypal
    createPaypalSubscription() {
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const paypalSubscription = httpsCallable(
          functions,
          "paypalSubscription"
        );

        paypalSubscription({
          packageTitle: this.packageTitle,
          plan_id: this.plan_id,
          quantity: this.quantity,
          subscriber: this.firstName + " " + this.lastName,
          email: this.email,
          subscriptionUid: this.newSubscriptionUid,
        }).then((result) => {
          this.overlay = false;
          this.checkOutLink = result.data.response.subscriptionData.links[0].href
          this.$store.commit("setCheckOutLink", this.checkOutLink);
          window.location.href = this.checkOutLink
        });
      } catch (err) {
        console.log("err", err);
        this.overlay = false;
        this.overlayPaymentMethodError = true;
        this.catchErrorMessage = err.message;
      }
    },
    //handel the change of card
    handleCheckboxChange(itemId) {
      if (itemId) {
        this.selectedCard = itemId;
      }
    },
    //regenerate competitive report
    regenerateCompetitiveReport() {
      this.overlayError = false;
      this.regenerateCompetitive = false;
      this.overlayBusyGeneratingReport = true;
      this.generateCompetitiveAnalysisReportPopup = true;
      this.createReport();
    },
    // Create competitive analysis report
    createReport() {
      this.displayContinue = false
      this.generateCompetitiveAnalysisReportPopup = true;
      this.overlayBusyGeneratingReport = true;

      const pageIds = this.packagePages.map((page) => page.id);
      const functions = getFunctions(firebaseApp, "europe-west2");
      const generateCompetitiveAnalysisReport = httpsCallable(
        functions,
        "generateCompetitiveAnalysisReport",
        {timeout: 540000}
      );

      generateCompetitiveAnalysisReport({
        pageIds: pageIds,
        agencyId: this.agencyProfile.agencyId,
        subscriptionUid: this.newSubscriptionUid,
        reportType: "subscription"
      })
        .then((result) => {
          console.log("result", result);
          this.competitiveReportUid = result.data.response;
          console.log("this.competitiveReportUid", this.competitiveReportUid);
          if (this.packageTitle == "Package 1") {
            this.generateCompetitiveAnalysisReportPopup = false;
            this.emailingClient = true;
            this.emailAdmins();
          } else if (this.packageTitle == "Package 3") {
            this.overlay = false;
            this.showCards = false;
            this.generateCompetitiveAnalysisReportPopup = false;
            this.overlayBusyGeneratingReport = false;
            this.competitiveReportData = false;
            this.insightsReportData = true;
            this.checkForPageAccess();
            this.checkingForAccess = true;
          }
        })
        .catch((error) => {
          console.log('generateCompetitiveAnalysisReport', error);
          this.overlay = false;
          this.overlayBusyGeneratingReport = false;
          this.generateCompetitiveAnalysisReportPopup = false;
          this.regenerateCompetitive = true;
          this.overlayError = true;
          this.catchErrorMessage = `${error.message} error. Please try again or contact your account manager.`;
        });
    },
    // regenerate facebook insights report
    regenerateFacebookInsightsReport() {
      this.overlayError = false;
      this.regenerateFacebookInsights = false;
      this.overlayBusyGeneratingReport = true;
      this.generatingFacebookInsightsReport = true;
      this.generateInsightsReportNow();
    },
    //Generates the insights reports for the current selected page
    async generateInsightsReportNow() {
      this.displayContinue = false
      this.overlayBusyGeneratingReport = true;
      this.generatingFacebookInsightsReport = true;
      
      let facebookToken = "";

      // if (
      //   this.packageTitle == "Package 2" && this.demoPackage ||
      //   this.packageTitle == "Package 3" && this.demoPackage || this.packageTitle == "Package 3"
      // ) {
      //   this.overlayBusyGeneratingReport = true;
      //   this.generatingFacebookInsightsReport = true;
      // }

      if (this.$store.state.facebookToken != "") {
        facebookToken = this.$store.state.facebookToken;
      } else if (this.$store.state.user.facebookToken != "") {
        facebookToken = this.$store.state.facebookToken;
      }

      const functions = getFunctions(firebaseApp, "europe-west2");
      const generateInsightsReport = httpsCallable(
        functions,
        "generateInsightsReport",
        {timeout: 540000}
      );

      await generateInsightsReport({
        userToken: facebookToken,
        primaryPageId: this.packagePages[0].id,
        adAccountId: this.adsAccountId,
        pageToken: this.primaryPageToken,
        agencyId: this.agencyProfile.agencyId,
        subscriptionId: this.newSubscriptionUid,
        subscriberId: this.newSubscription.subscriberId,
        singlePage: this.singlePage,
      })
        .then((result) => {
          this.facebookInsightsReportUid =
            result.data.response.facebookInsightsReportUid;
          this.instagramInsightsReportUid =
            result.data.response.instagramInsightsReportUid;
          this.generatingFacebookInsightsReport = false;
          this.generatingInstgramInsightsReport = true;
          setTimeout(() => {
            this.generatingInstgramInsightsReport = false;
            this.emailingClient = true;
            this.emailAdmins();
          }, 2000);
          return;
        })
        .catch((err) => {
          console.log(err);
          this.overlayBusyGeneratingReport = false;
          this.generatingFacebookInsightsReport = false;
          this.regenerateFacebookInsights = true;
          this.overlay = false;
          this.overlayError = true;
          this.catchErrorMessage = `Something went wrong generating the Facebook Insights Report.`;
          return;
        });
    },
    // Cloud function to email subscriber logins once the report has been generated
    emailAdmins() {
      if(this.packageTitle == 'Package 3' && this.noAccessMessage){
        this.overlayBusyGeneratingReport = true;
        this.emailingClient = true;
      }

      const functions = getFunctions(firebaseApp, "europe-west2");
      const emailSubscriberLogins = httpsCallable(
        functions,
        "emailSubscriberLogins"
      );

      emailSubscriberLogins({
        subscriberEmail: this.email,
        subscriptionId: this.newSubscriptionUid,
        reportId: this.competitiveReportUid,
        facebookInsightsReportUid: this.facebookInsightsReportUid,
        instagramInsightsReportUid: this.instagramInsightsReportUid,
        agency: this.agencyProfile,
        packageTitle: this.packageTitle,
        packagePages: this.packagePages,
        pageName: this.packagePages[0].name,
        subscriberName: this.firstName + " " + this.lastName,
        subscriberPassword: this.password,
        newUser: this.newUser,
        packageType: this.packageType,
      })
        .then((result) => {
          if (result.data.response.success == true) {
            this.overlay = false;
            this.overlayBusyGeneratingReport = false;
            this.emailingClient = false;
            this.alertType = "success";
            this.successResponse =
              "Subscription and Competitive Analysis Report Created Successfully, and emails have been sent";
            this.redirecting = true;
            this.newSubscription = {};
            this.checkOutLink = ''
            this.password = ''
            this.newUser = false
            this.hasAccess = false;
            this.$store.commit("setFrontEndSubscription", this.newSubscription);
            this.$store.commit("setCheckOutLink", this.checkOutLink);
            this.$store.commit("setNewUserPassword", this.password);
            this.$store.commit("setIfNewUser", this.newUser); 
            this.$store.commit("setHasAccess", this.hasAccess);
            setTimeout(() => {
              window.location.href = "https://compeat.social/thank-you/";
              this.redirecting = false;
            }, 3000);
          } else {
            console.log("email error");
            this.overlayBusyGeneratingReport = false;
            this.overlayEmailError = true;
            this.catchErrorMessage = `Email was not sent. Please email client from subscription page.`;
          }
        })
        .catch((error) => {
          console.log(error);
          this.overlayBusyGeneratingReport = false;
          this.overlayError = true;
          this.catchErrorMessage = `${error.message} test`;
        });
    },
    // delete pages from packagePages array
    deletePage(index) {
      if (
        this.packageTitle == "Package 1" ||
        this.packageTitle == "Package 3"
      ) {
        this.packagePages.splice(index, 1);
      } else if (this.packageTitle == "Package 2") {
        this.packagePages.splice(index, 1);
        this.hasAccess = false;
        this.adsAccountsForPage = [];
      }
    },
    //Displays the correct form for the selected package
    handleSelect(value) {
      if (value == "CAO") {
        this.package1();
      } else if (value == "ISO") {
        this.package2();
      } else if (value == "CAIS") {
        this.package3();
      }
    },
    //Package 1 setup
    package1() {
      this.packageUpgraded = true;
      this.packageTitle = "Package 1";
      this.priceTotal = 50;
      this.pagesToAdd = 5;
      this.competitiveReportData = true;
      this.insightsReportData = false;

    },
    //Package 2 setup
    package2() {
      this.packageTitle = "Package 2";
      this.priceTotal = 150;
      this.insightsReportData = true;
      //   this.getAdsAccountsForPage();
    },
    //Package 3 setup
    package3() {
      this.packageTitle = "Package 3";
      this.priceTotal = 185;
      this.pagesToAdd = 5;
      this.competitiveReportData = true;
      this.insightsReportData = false;
    },
    // Valids Form
    validatePackageOneAndTwo() {
      this.$refs.packageOneForm.validate();
    },
    // Valids Form
    validatePackageThree() {
      this.$refs.packageThreeForm.validate();
    },
    //Formats the number in the mobile field
    onInput(formattedNumber, { number }) {
      this.mobile = number.international;
    },
    // Handels the selected ad account for insights
    handleSelectedAdAccount(value) {
      this.adsAccountId = value;
    },
    //Cancel creating new user error
    cancelError() {
      this.overlayError = false;
      this.catchErrorMessage = "";
    },
    contactSupport() {
      // You can replace the URL below with the desired destination
      window.location.href = "https://compeat.social/contact/";
    },
    //Cancel the unsuccessful payment popup
    cancelUnsuccessfulPayment() {
      this.paymentResponseDialog = false;
      this.paymentResponse = false;
    },
    //If client cancels payment and diplay reason why
    anotherTime(){
      this.reason = true
    },
    //Move the subscription to a cancelled payment collection
    async cancelledSubscriptionPayment(){
      this.displayCancelled = false
      this.redirecting = true
      try{

      // Add a new document with a generated id
      const canceledPaymentClientRef = doc(collection(db, "cancelledPayment"));

      this.newSubscription.reasonForLeaving = this.reasonForLeaving

      await setDoc(canceledPaymentClientRef, this.newSubscription);

     // Delete the document by its ID
      await deleteDoc(doc(db, 'subscriptions', this.newSubscriptionUid));
      
      this.displayCancelled = false
      this.newSubscription = {};
      this.$store.commit("setFrontEndSubscription", this.newSubscription);
      window.location.href = 'https://compeat.social/contact/'
      this.redirecting = false

      }catch(err) {
        this.redirecting = false
        console.error('Error deleting document:', err);
      }
    },
    //If client wants to check out again
    proceedToCheckOut(){
      this.displayCancelled = false
      this.redirecting = true
      this.$gtag.event('begin_checkout', {
        event_category: 'user_engagement',
        event_label: 'begin_checkout' ,
        value: this.newSubscription.package.priceTotal
      })
      setTimeout(() => {
        window.location.href = this.$store.state.checkOutLink
        this.redirecting = false
      }, 2000)
    },
    //For email field
    convertToLowercase() {
      this.email = this.email.toLowerCase(); // Transform input to lowercase
    },
    goToPackages(){
      this.tooManyDemoReports = false
      window.location.href = "https://compeat.social/packages/";
    },
  //   async deleteSubscriptions() {
  //   let list = []; // Not used in your code
  //   let myList = [];

  //   const querySnapshot = await getDocs(collection(db, "reports"));

  //   for (const doc of querySnapshot.docs) {
  //       console.log(doc.id, " => ", doc.data());

  //       if (doc.id == 'D5o2Mchvin8OT4DGllEJ' ||
  //           doc.id == 'R1XotFKMeKmBhi9tjfHn' ||
  //           doc.id == 'PuoFhOg9Ck7vnqv6tYGg' ||
  //           doc.id == '1iZaw1uMxPxVu9Mh8cn5' ||
  //           doc.id == '4TVFvxIbPB6dBL7dZ0CQ' ||
  //           doc.id == 'OyAuyF7LNm5Pa2bmBQe7') {
  //           myList.push(doc.data());
  //       } else {
  //           await deleteDoc(doc.ref); // Changed doc(db, 'subscriptions', doc.id) to doc.ref
  //       }
  //   }

  //   console.log('myList', myList.length);
  //   console.log('list', list.length); // This will always log 0 as list is not used
  // }
}
};
</script>

<style scoped>
.steptext {
  font-family: "Poppins", sans-serif;
  font-weight: 800;
  text-transform: uppercase;
  /* line-height: 45px; */
}

.pricetext {
  font-size: 40px;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 0px;
}

.bordercard {
  border: 3px solid #c03b7d;
}

.stripetext {
  font-size: 12px;
}

.bold {
  font-weight: 600;
}
</style>
